module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    style: (_vm.starPower)
  }, [(_vm.isGameOver) ? _c('app-game-over-modal') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "about-button",
    on: {
      "click": _vm.aboutToggle
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.aboutShow) ? _c('i', {
    key: "menu",
    staticClass: "material-icons icon-menu"
  }, [_vm._v("menu")]) : _c('i', {
    key: "close",
    staticClass: "material-icons icon-close"
  }, [_vm._v("close")])])], 1), _vm._v(" "), _c('main', [_c('header', {
    class: _vm.classHeader
  }, [_c('h1', {
    staticStyle: {
      "color": "whitesmoke"
    }
  }, [_vm._v("חידון על מחשבים")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "expand",
      "mode": "out-in"
    }
  }, [(_vm.aboutShow) ? _c('app-about') : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c(_vm.currentView, {
    tag: "component"
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55ca0de3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 48
// module chunks = 0